export const SLIDER_MANAGEMENT = {
  BASE_PATH: "/cms/slider-management/",
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  ADD_BUTTON_TITLE: "Add New Slider Management",
  LIST_PAGE_TITLE: "Slider Management List",
  EDIT_PAGE_TITLE: "Edit Slider Management",
  GET_ALL: "/cms/slider-management/list",
  GET_ONE: "/slider-management/edit/",
  GET_ALL_REGIONS: "/slider-management/region",
  CREATE: "/cms/slider-management/create",
  UPDATE: "/slider-management/update/",
  DELETE: "/cms/slider-management/delete/",
  ADD_NEW_TITLE: "Add New Slider Management",
};
